import { Subject } from 'rxjs';
import { Responsible } from 'src/app/model/responsible';
import { ObjectUtil } from '../ObjectUtil';

export class TableResponsibleUser {
  static propCheck = 'checked';

  private elements: Array<Responsible>;
  private elementSelecteds: Array<Responsible>;
  public responsibleUsers = new Subject<Array<Responsible>>();

  constructor() {
    this.elements = [];
  }

  updateElement(el: any, obj: {}) {
    const indexElement = this.elements.indexOf(el);
    Object.assign(this.elements[indexElement], obj);
    this.responsibleUsers.next(this.elements);
  }

  updateElements(ev: any) {
    this.elements.forEach((el) => Object.assign(el, ev));
    this.responsibleUsers.next(this.elements);
  }

  updateByElementId(ev: any) {
    this.elements.some((el) => {
      if (el.id && el.id === ev.id) {
        Object.assign(el, ev);
      }
    });
  }

  getElementOptions(element): any {
    return { span: '', value: element[TableResponsibleUser.propCheck] };
  }

  getElementSelected(): Array<Responsible> {
    return this.elementSelecteds;
  }

  getList(filter: string) {
    this.responsibleUsers.next(
      this.elements.filter((item) =>
        Object.keys(item).some(
          (k) =>
            item[k] != null &&
            item[k].toString().toLowerCase().includes(filter.toLowerCase())
        )
      )
    );
  }

  removeEl(user: Responsible) {
    const index = this.elements.indexOf(user);
    this.elements.splice(index, 1);
    this.responsibleUsers.next(this.elements);
  }

  addEl(user: Responsible) {
    this.elements.push(user);
    this.responsibleUsers.next(this.elements);
  }

  addList(users: Array<Responsible>) {
    this.elements = Object.assign([], users);
    this.responsibleUsers.next(this.elements);
  }

  addListSelecteds(users: Array<Responsible>) {
    this.elementSelecteds = Object.assign([], users);
    this.responsibleUsers.next(this.elementSelecteds);
  }

  mergeList(users: Array<Responsible>) {
    let counter = 0;
    users.forEach((user) => {
      const isNewUser = this.mergeById(user);
      if (isNewUser) {
        counter++;
      }
    });
    this.responsibleUsers.next(this.elements);
    return counter;
  }

  private mergeById(user: Responsible) {
    let findUser;
    this.elements.some((el) => {
      if (el.id && el.id === user.id) {
        findUser = Object.assign(el, user);
        return true;
      }
    });

    if (!findUser || ObjectUtil.isEmpty(findUser)) {
      this.elements.push(user);
      return true;
    }
    return false;
  }

  anyCheckedElement(): boolean {
    return this.elements.anyChecked(TableResponsibleUser.propCheck);
  }

  countCheckedElements(): number {
    if (!this.elementSelecteds) {
      return 0;
    }

    return this.elementSelecteds.filter((el) => el[TableResponsibleUser.propCheck]).length;
  }

  deselectAll() {
    this.elementSelecteds = [];
    this.elements.forEach((el) => (el[TableResponsibleUser.propCheck] = false));
    this.responsibleUsers.next(this.elements);
  }

  selectAll() {
    this.elementSelecteds = [];
    this.elements.forEach((el) => (el[TableResponsibleUser.propCheck] = true));
    this.responsibleUsers.next(this.elements);
    this.elementSelecteds = this.elements.filter((el) => el[TableResponsibleUser.propCheck]);
  }

  contains(prop, value) {
    return this.elements.some((el) => el[prop] == value);
  }

  changeElementPropertyValue(el, propName, propNewValue) {
    const indexElement = this.elements.indexOf(el);
    this.elements[indexElement][propName] = propNewValue;
    this.responsibleUsers.next(this.elements);
  }
}
